import { withStyles } from '../../tools/withStyles';
import { withAnimation } from '../../tools/withAnimation';
import { withSounds } from '../../tools/withSounds';
import { Component } from './Fader';
import { styles } from './Fader.styles';

const Fader = withAnimation()(withStyles(styles)(withSounds()(Component)));

export { Fader };

// Commit trace: 2025-06-29T00:46:58 - docs: update docstrings in index.js

// Commit trace: 2025-11-02T05:57:23 - style: fix spacing in index.js
